import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Card } from '#pie/components/card/Card';
import { DataTable } from '#pie/components/data-table/DataTable';
import { InputSearch } from '#pie/components/input-search/InputSearch';
import { Page, PageHeader } from '#pie/components/page/Page';
import { PageHead } from '#pie/components/page-head/PageHead';
import { Stack } from '#pie/components/stack/Stack';
import { useDataTable } from '#pie/hooks/useDataTable';
import { getMarketParties } from '#pie/internal/api/pie-bff';
import { invoiceContactSortingAtom } from '#pie/stores/invoiceContact';
import { searchAtom } from '#pie/stores/search';
import { emptyFilterAtom } from '#pie/stores/searchOnlyFilter';

export const InvoiceContactRegister = () => {
  const { t } = useTranslation();

  const tableProps = useDataTable({
    columns: (helper) => [
      helper.accessor('name', {
        cell: (info) => (
          <Link
            className="text-content-link"
            to={`${info.row.original.mprIdMarketParty}/${info.row.original.mprIdSubUnit}`}
            aria-label={info.getValue()}
            data-title={info.getValue()}
          >
            {info.getValue()}
          </Link>
        ),
        header: t('common.name'),
        meta: { columnWidth: 400 },
      }),
      helper.accessor('ean13', {
        header: t('common.ean13'),
        meta: { columnWidth: 400 },
      }),
      helper.accessor('accountType', {
        cell: (info) => {
          const value = info.getValue();
          return t(`invoice_contact.table.accountType.${value}`, {
            defaultValue: '-',
          });
        },
        header: t('invoice_contact.table_header.registration_type'),
        meta: { columnWidth: 400 },
      }),
    ],
    dateKeys: [],
    filtersAtom: emptyFilterAtom,
    query: getMarketParties,
    sortingAtom: invoiceContactSortingAtom,
  });

  const [search, setSearch] = useAtom(searchAtom);

  return (
    <>
      <PageHead title={t('invoice_contact_register.title')} />
      <Page>
        <PageHeader title={t('invoice_contact_register.title')} />
        <section className="flex items-start gap-6">
          <Card className="flex-1 overflow-x-hidden p-4">
            <Stack gap="md">
              <div className="px-3" role="toolbar">
                <InputSearch
                  value={search || ''}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={t('common.search.placeholder')}
                  onClear={() => setSearch('')}
                />
              </div>
              <DataTable
                rowLinks={(row) => ({
                  'aria-label': row.original.name,
                  to: `${row.original.mprIdMarketParty}/${row.original.mprIdSubUnit}`,
                })}
                {...tableProps}
                getRowId={(row) => row.id}
              />
            </Stack>
          </Card>
        </section>
      </Page>
    </>
  );
};
